import { render } from "./JMessageArticlePanel.vue?vue&type=template&id=8f0b71c0&scoped=true&ts=true"
import script from "./JMessageArticlePanel.vue?vue&type=script&lang=ts"
export * from "./JMessageArticlePanel.vue?vue&type=script&lang=ts"

import "./JMessageArticlePanel.vue?vue&type=style&index=0&id=8f0b71c0&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f0b71c0"]])

export default __exports__